export default __webpack_public_path__ + "static/media/letterOfOffer.22d7b6ab.png";